var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5",attrs:{"fluid":""}},[(_vm.egertons)?_c('egertons-cnp'):_c('master-cnp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }